module.exports = __webpack_public_path__ + "static/media/acebackground-rotated.2a7b49c8.jpg";